import { useCallback, useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SourceContent({
  icon,
  secondaryText,
  primaryText
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "start",
    alignItems: "center",
    gap: "200",
    overflow: "hidden",
    children: [icon, /*#__PURE__*/_jsxs(Text, {
      as: "p",
      typography: "heading-25",
      color: "text-core-default",
      truncate: true,
      margin: "0",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "span",
        children: primaryText
      }), primaryText && secondaryText && /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "detail-100",
        color: "text-core-default",
        children: ' | '
      }), /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "detail-100",
        color: "text-core-default",
        children: secondaryText
      })]
    })]
  });
}
function Source({
  primaryText,
  icon,
  secondaryText,
  data,
  onClick,
  disabled = false
}) {
  const [isHovered, setIsHovered] = useState(false);
  const handleClick = useCallback(() => {
    onClick === null || onClick === void 0 || onClick(data);
  }, [onClick, data]);
  const handleKeyDown = useCallback(event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  }, [handleClick]);
  const isClickable = !disabled && !!onClick;
  if (isClickable) {
    return /*#__PURE__*/_jsx(View, {
      backgroundColor: isHovered ? 'fill-surface-recessed' : undefined,
      borderRadius: "200",
      children: /*#__PURE__*/_jsx(Button, {
        use: "unstyled",
        onClick: handleClick,
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: () => setIsHovered(false),
        onKeyDown: handleKeyDown,
        block: true,
        paddingInline: "300",
        paddingBlock: "200",
        borderRadius: "200",
        width: "100%",
        children: /*#__PURE__*/_jsx(Flex, {
          inlineSize: "100%",
          justifyContent: "start",
          alignItems: "center",
          children: /*#__PURE__*/_jsx(SourceContent, {
            icon: icon,
            secondaryText: secondaryText,
            primaryText: primaryText
          })
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "300",
    paddingBlock: "200",
    borderRadius: "200",
    children: /*#__PURE__*/_jsx(SourceContent, {
      icon: icon,
      secondaryText: secondaryText,
      primaryText: primaryText
    })
  });
}
export { Source };